import { IFillDataWizardSell, TKeyOfDataWizardSell, TNumberKeysOfIFillDataWizardSell } from "../..";
import DoNotKnowPrice_1 from "../doNotNowPrice/step_1";
import DoNotKnowPrice_2 from "../doNotNowPrice/step_2";
import DoNotKnowPrice_3 from "../doNotNowPrice/step_3";

const getDoNotKnowSteps = (
  dataFormEstimate: Partial<IFillDataWizardSell>,
  dataFeatures: Partial<IFillDataWizardSell>,
  onReset: (keys: TKeyOfDataWizardSell[], data?: number[]) => void,
  handleChangeDataNumber: (data: number | number[], key: TNumberKeysOfIFillDataWizardSell) => void,
  handleChangeDataObject: (data: Partial<IFillDataWizardSell>) => void,
  disabledAndPrev: {
    isNextStep_estimate: boolean;
    isNextStep_dataFeatures: boolean;
  }
) => {
  const { isNextStep_estimate, isNextStep_dataFeatures } = disabledAndPrev;

  return [
    <DoNotKnowPrice_1
      onChangePrice={handleChangeDataNumber}
      onChange={handleChangeDataObject}
      onReset={onReset}
      isNextStepDisabled={isNextStep_estimate}
      dataFormEstimate={dataFormEstimate}
    />,
    <DoNotKnowPrice_2
      onChange={handleChangeDataObject}
      data={dataFeatures}
      isNextStepDisabled={isNextStep_dataFeatures}
      onReset={onReset}
    />,
    <DoNotKnowPrice_3 />,
  ];
};

export default getDoNotKnowSteps;
